import { GetProjectPublishedStatus } from '@/connection/projects/get-project-published-status';
import { serializeError } from '@/store/utils/serialize-error';
import { ProjectStateReducerCreator } from '../types';
import type { RootState } from '@/store/root-state';

const getPublishedEventUrlReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async ({ eventUuid }: { eventUuid: string }, { rejectWithValue }) => {
      try {
        const result = await GetProjectPublishedStatus(eventUuid);
        if ('error' in result) {
          console.error('getPublishedEventUrl error', result.error);
          return rejectWithValue(serializeError(result.error));
        }
        return result;
      } catch (e) {
        return rejectWithValue(serializeError(e));
      }
    },
    {
      options: {
        condition: (_, { getState }) => {
          const state = getState() as RootState;
          return !state.project.checkingPublishedStatus;
        },
      },
      fulfilled: (state, action) => {
        if (action.payload) {
          state.projectPublishedStatus = action.payload;
          state.checkingPublishedStatus = false;
        }
      },
      pending: (state) => {
        state.checkingPublishedStatus = true;
      },
      rejected: (state, action) => {
        state.checkingPublishedStatus = false;
        console.error(action.error);
      },
      settled: (state) => {
        state.publishStatusKnown = true;
      },
    }
  );
};

export default getPublishedEventUrlReducer;
